import { Pipe, PipeTransform } from '@angular/core';
import { FilterOperatorsEnum } from '../models/general.models';

@Pipe({ name: 'filterChip' })
export class FilterChipPipe implements PipeTransform {
  transform(
    value: string | string[] | number | null | undefined,
    type: FilterOperatorsEnum,
    truncateLength: number = 30
  ): { display: string; tooltip?: string } {
    if (value === null || value === undefined) return { display: '' };

    let fullValue: string;
    if (type === FilterOperatorsEnum.IN && Array.isArray(value)) {
      fullValue = value.join(', ');
    } else {
      fullValue = String(value);
    }

    const isTooLong = fullValue.length > truncateLength;
    const display = isTooLong
      ? `${fullValue.substring(0, truncateLength)  }…`
      : fullValue;

    return {
      display,
      tooltip: isTooLong ? fullValue : undefined
    };
  }
}
